export default "dist/images/block-count-up-abstract.5995f2d.png";